var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-tr",
    {
      staticClass: "custom-table__row",
      nativeOn: {
        click: function ($event) {
          return _vm.$emit("clickedRow", _vm.record)
        },
      },
    },
    [
      _c("mds-td", { staticClass: "custom-table__column" }, [
        _vm._v(_vm._s(_vm.record.name)),
      ]),
      _vm._v(" "),
      _c(
        "mds-td",
        { staticClass: "custom-table__column" },
        [
          _c("schedule-status", {
            attrs: { status: _vm.record.status, "item-id": _vm.record.id },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("mds-td", { staticClass: "custom-table__column" }, [
        _c("div", [_vm._v(_vm._s(_vm.record.lastRun.date))]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.record.lastRun.date !== "—",
                expression: "record.lastRun.date !== '—'",
              },
            ],
            staticClass: "custom-table__time",
          },
          [_vm._v("\n      " + _vm._s(_vm.lastRunDate) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("mds-td", { staticClass: "custom-table__column" }, [
        _c("div", [_vm._v(_vm._s(_vm.record.nextRun.date))]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.record.nextRun.date !== "—",
                expression: "record.nextRun.date !== '—'",
              },
            ],
            staticClass: "custom-table__time",
          },
          [_vm._v("\n      " + _vm._s(_vm.nextRunDate) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("mds-td", { staticClass: "custom-table__column" }, [
        _vm._v(_vm._s(_vm.record.recurrence)),
      ]),
      _vm._v(" "),
      _c(
        "mds-td",
        { staticClass: "custom-table__column" },
        _vm._l(_vm.actions, function (action, key) {
          return _c(
            "mds-button",
            {
              key: key,
              staticClass: "custom-table__action",
              attrs: {
                icon: action.icon,
                disabled: _vm.disableDownload,
                size: "small",
                variation: "flat",
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.$emit(action.event, [_vm.record.id, $event])
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.translate(action.name)) + "\n    ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "mds-td",
        { staticClass: "custom-table__column" },
        [
          _c(
            "CustomTableActions",
            _vm._g(
              { attrs: { record: _vm.record, rowId: _vm.record.id } },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }